import { useEffect, useContext } from 'react';
import Log from 'forms-utils-lib/logger/Logger';
import useShouldShowNotificationRecipientBanner from './internal/NotificationRecipientBanner/useShouldShowNotificationRecipientBanner';
import NotificationRecipientBanner from './internal/NotificationRecipientBanner/NotificationRecipientBanner';
import getInvalidRecipients from './internal/NotificationRecipientBanner/getInvalidReceipients';
import TrackingContext from 'ui-forms-components/contextProviders/TrackingContext';
import { DASHBOARD_BANNER } from 'ui-forms-components/constants/TrackingEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardBanner = () => {
  const {
    track
  } = useContext(TrackingContext);
  const [shouldShowNotificationRecipientBanner, updateNotificationRecipientLocalStorageKey] = useShouldShowNotificationRecipientBanner();
  useEffect(() => {
    if (shouldShowNotificationRecipientBanner) {
      track(DASHBOARD_BANNER.NOTIFICATION_RECIPIENT_BANNER_SHOWN);
    }
  }, [shouldShowNotificationRecipientBanner, track]);
  const onClose = (updateFcn, keyToTrack) => {
    track(keyToTrack);
    updateFcn();
  };
  const handleDownload = (fetchFcn, componentName, keyToTrack) => {
    track(keyToTrack);
    fetchFcn().catch(e => Log.error(`failed to downloaded the ${componentName} csv`, e));
  };
  if (shouldShowNotificationRecipientBanner) {
    return /*#__PURE__*/_jsx(NotificationRecipientBanner, {
      onClose: () => onClose(updateNotificationRecipientLocalStorageKey, DASHBOARD_BANNER.NOTIFICATION_RECIPIENT_BANNER_ALERT_DISMISSED),
      handleDownload: () => handleDownload(getInvalidRecipients, 'notification-recipient-banner', DASHBOARD_BANNER.NOTIFICATION_RECIPIENT_BANNER_CSV_DOWNLOAD)
    });
  }
  return null;
};
export default DashboardBanner;